import React, { useState } from 'react'

import AddIcon from '@mui/icons-material/Add'
import {
  Form as FormComponent,
  Grid,
  Input,
  Button,
  SelectForm
} from 'components'
import { useGet } from 'hooks'
import { useModal, useLoading, useException } from 'hooks'
import { useFormContext } from 'react-hook-form'
import { IEntityGST, IResponseTypes } from 'services/core/genericEntityGST'
import {
  CadastroSegurancaItensSubItensServices,
  IGetAllSubItensParams
} from 'services/GST/CadastroItensSubitensSeguranca'
import { IGetInfracoesResponse } from 'services/GST/Dicionarios'
import { SPACING } from 'utils'

import { useSecurityItensAndSubItens } from '../../../../../../context'
import { IFormAddSubItem } from '../../types'

interface IFormProps {
  refresh: (_params: IGetAllSubItensParams) => void
}

const Form: React.FC<IFormProps> = ({ refresh }) => {
  const { selectedItem } = useSecurityItensAndSubItens()
  const { showModal } = useModal()
  const { createCustomException, getException } = useException()
  const { setLoading } = useLoading()
  const [isEditing, setIsEditing] = useState<boolean>(false)

  const {
    control,
    handleSubmit,
    formState: { errors },
    reset
  } = useFormContext<IFormAddSubItem>()
  const { data } = useGet<{}, IEntityGST<IGetInfracoesResponse[]>>({
    api: 'Gst',
    params: {},
    url: 'Infracao/GetInfracaoToDictionary'
  })

  const handleSubmitForm = (form: IFormAddSubItem) => {
    setLoading('loading')

    CadastroSegurancaItensSubItensServices()
      .createSubItemSeguranca({
        idInfracaoSubItemSeguranca: form.idInfracaoSubItemSeguranca,
        idSubItemSeguranca: 0,
        itemSegurancaId: selectedItem.idItemSeguranca,
        nmSubItemSeguranca: form.nmSubItemSeguranca,
        txSubItemDescricao: form.txSubItemDescricao
      })
      .then((response) => {
        if (response.status !== 200) {
          const { tipo, mensagem, detalhe } = response.data

          createCustomException({
            detalhe,
            mensagem,
            tipo: IResponseTypes[tipo]
          })
        }

        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message: 'SubItem criado com sucesso!',
          txtButtonConfirm: 'OK',
          type: 'success'
        })
        refresh({
          idItemSeguranca: selectedItem.idItemSeguranca,
          pageNumber: 1
        })
        reset({
          idInfracaoSubItemSeguranca: 0,
          nmSubItemSeguranca: '',
          txSubItemDescricao: ''
        })
      })
      .catch((err: Error) => {
        setLoading('idle')
        const error = getException(err)

        showModal({
          hideButtonCancel: true,
          message: error.mensagem || 'Não foi possível criar o subitem',
          txtButtonConfirm: 'OK',
          type: error.tipo || 'error'
        })
      })
  }

  return (
    <FormComponent
      onSubmit={handleSubmit(handleSubmitForm)}
      marginBottom={SPACING.spacing10}
    >
      <Grid
        gridCols="3fr 3fr 3fr 1fr"
        gridGap={`0 ${SPACING.spacing20}`}
        margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
      >
        <Input
          control={control}
          errors={errors}
          label="Subitem de Segurança"
          placeholder="Subitem de Segurança"
          formValue="nmSubItemSeguranca"
          required
        />
        <Input
          control={control}
          errors={errors}
          placeholder="Descrição do Subitem"
          label="Descrição do Subitem"
          formValue="txSubItemDescricao"
          required
        />
        <SelectForm
          control={control}
          errors={errors}
          placeholder="Selecione"
          listOptions={
            data?.entity?.map((infracao) => ({
              label: infracao.nuNivelInfracao,
              value: infracao.idInfracao
            })) || []
          }
          label="Infração"
          formValue="idInfracaoSubItemSeguranca"
          required
        />
        <Button
          variantButton="default"
          text="ADICIONAR ITEM"
          startIcon={<AddIcon />}
          type="submit"
          width={'max-content'}
          marginTop={SPACING.spacing10}
        />
      </Grid>
    </FormComponent>
  )
}

export default Form
